// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
// должен быть множественный выбор параметров./
export let AlertNotification =
{
    SHOW_POP_UP: 1,  //Значение по умолчанию
    SOUND: 2,
    EMAIL: 4,
    PUSH: 8
    // 1=Popup, 2=Sound, 4=Email, 8=Push  из доки не брать, Макс написал https://tp.traderevolution.com/entity/90577
}
export let AlertNotificationMap =
{
    1: "Show Pop-up",    //Значение по умолчанию
    2: "Sound",
    4: "Email",
    8: "Push"
}